"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextBubbleFullBase = void 0;
class TextBubbleFullBase {
    constructor(scene, imagesList, getDevicePixelRatio, textBubbleController) {
        this.textureScale = 1;
        this.bubbleType = 0;
        this.isRawText = false;
        this.isTextWithHtml = false;
        this.isRendered = false;
        this.isAnimated = true;
        this.isVisibleText = true;
        this.isVisibleComments = true;
        this.isTextFieldToChange = true;
        this.textBubble = null;
        this.gameplayScene = scene;
        this.textBubbleController = textBubbleController;
        this.getDevicePixelRatio = getDevicePixelRatio;
        this.imagesList = imagesList;
        this.canvasWidth = this.gameplayScene.cameras.main.width;
        this.canvasHeight = this.gameplayScene.cameras.main.height;
    }
    uninit() { }
    destroy() {
        this.isRendered = false;
        this.animatesStop();
    }
    hide() {
        this.destroy();
    }
    animatesStop() {
    }
    getBubbleType() {
        return this.bubbleType;
    }
    setBubbleType(type) {
        this.bubbleType = type;
    }
    calcElementsBoundsData() {
        if (this.textBubble) {
            this.textBubble.calcElementsBoundsData();
        }
    }
    getElementBoundsData() {
        if (this.textBubble) {
            return this.textBubble.getElementBoundsData();
        }
        return false;
    }
    animateMe() { }
    /**
     * Set to true if you need to display raw text
     */
    setIsRawText(isRawText = false) {
        this.isTextFieldToChange = (this.isRawText != isRawText);
        this.isRawText = isRawText;
    }
    setIsAnimated(isAnimated = true) {
        this.isAnimated = isAnimated;
    }
    setIsVisibleText(isVisibleText = true) {
        this.isVisibleText = isVisibleText;
    }
    setIsVisibleComments(isVisibleComments = true) {
        this.isVisibleComments = isVisibleComments;
    }
    checkIfRendered() {
        return this.isRendered;
    }
    getFullWidth() {
        return 0;
    }
    getFullHeight() {
        return 0;
    }
}
exports.TextBubbleFullBase = TextBubbleFullBase;
